import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-point-blue",
  "use": "icon-point-blue-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-point-blue\"><path d=\"M512 320a192.064 192.064 0 0 1 0 384 192 192 0 0 1 0-384z\" fill=\"#1296db\" p-id=\"22317\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol